import React from 'react';
import { ToolComponentProps } from './types';
import { ChevronRight, ChevronDown } from 'lucide-react';

export const ErrorReportsUpdateTool: React.FC<ToolComponentProps> = ({
  input,
  output,
  isError,
  isExpanded,
  onToggle
}) => {
  const action = input?.action || 'update';
  const groupId = input?.group_id;
  const comment = input?.comment || '';
  const hasOutput = output !== undefined && output !== null;

  const actionLabel = action === 'resolve' ? 'Resolve' : action === 'suppress' ? 'Suppress' : 'Update';
  const actionColor = action === 'resolve' ? 'text-green-600' : action === 'suppress' ? 'text-orange-600' : '';

  return (
    <div>
      <div
        className={`flex items-center gap-1 ${hasOutput ? 'cursor-pointer hover:bg-accent/30' : ''} rounded transition-colors`}
        onClick={hasOutput ? onToggle : undefined}
      >
        <span className="flex-1">
          Update Runtime Error: <span className={actionColor}>{actionLabel}</span> #{groupId}
        </span>
        <span className="text-muted-foreground inline-block w-3">
          {hasOutput && (isExpanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />)}
        </span>
      </div>

      {isExpanded && hasOutput && (
        <div className={`mt-2 rounded`}>
          {isError ? (
            <div className="p-2 rounded bg-destructive/10 text-destructive">
              <pre className="whitespace-pre-wrap text-xs">
                {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
              </pre>
            </div>
          ) : (
            <div className="bg-muted rounded p-2">
              {comment && (
                <div className="mb-2 text-xs">
                  <span className="text-muted-foreground">Comment:</span>{' '}
                  <span className="text-foreground">{comment}</span>
                </div>
              )}
              <pre className="whitespace-pre-wrap text-xs text-muted-foreground">
                {typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
